<template>
  <div>
    <div class="d-flex align-items-center">
      <McButton
        :text="$t('global.action.uploadPhoto')"
        variant="Primary"
        icon="icon-outline_upload"
        class="mc-btn__sm"
        @click="handleLoadFile"
        :disabled="isLoading || isSubmitting"
      />
      <div class="ms-2">{{ truncateFilename }}</div>
    </div>

    <input
      type="file"
      ref="file-input-ref"
      :accept="fileAccepted.join(', ')"
      @change="handleFileChanged"
      hidden
    />
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton
  },
  props: {
    isSubmitting: {
      type: Boolean,
      require: true 
    },
    filename: {
      type: String,
      require: true 
    }
  },
  emits: ['update:filename'],
  data() {
    return {
      isLoading: false,
      fileSize: null,
      fileId: null,
      file: undefined,
    }
  },
  computed: {
    fileAccepted() {
      return [
        'application/pdf',
        'image/jpg',
        'image/png',
        'image/jpeg'
      ]
    },
    truncateFilename() {
      if(this.filename.length <= 35) return this.filename
      const filenameArr = this.filename.split('.')
      const ext = filenameArr[filenameArr.length - 1]
      return `${this.filename.substring(0, 30)}...${ext}`
    }
  },
  methods: {
    handleLoadFile() {
      if (this.isLoading) {
        this.$mcToast.warning('Mohon Tunggu')
        return
      }

      this.$refs['file-input-ref'].click()
    },
    handleFileChanged(event) {
      this.isLoading = true

      const [file] = event.target.files
      if (!file) {
        this.isLoading = false
        return
      }

      this.file = file
      this.uploadFile()
    },
    async uploadFile() {
      if (!this.fileAccepted.includes(this.file.type)) {
        this.$mcToast.error('Unggah gagal. Format file tidak sesuai.')

        this.resetInputFile()
        return
      }

      let fileSize = this.file.size
      const MAX_FILE_SIZE = 1024 * 1024 * 5 // 5MB
      if (fileSize > MAX_FILE_SIZE) {
        this.$mcToast.error('Unggah gagal. Ukuran file melebihi batas ketentuan (5MB).')

        this.resetInputFile()
        return
      }

      this.$emit('update:filename', this.file.name)

      fileSize = this.file.size / 1024 / 1024
      this.fileSize = fileSize.toFixed(2)

      this.isLoading = false
    },
    resetInputFile() {
      this.$emit('update:filename', '')
      this.fileSize = null
      this.file = undefined
      this.isLoading = false
    }
  }
}
</script>
